// components/JobDetails.jsx
import React, { useState } from "react";
import { FaDollarSign, FaClock } from "react-icons/fa";
import { MdLocationOn, MdCalendarToday } from "react-icons/md";
import { HiBookmark, HiOutlineLightningBolt } from "react-icons/hi";
import QuickApplyModal from "./QuickApplyModal";

const JobDetails = ({ job, onClose }) => {
  const [showApplyModal, setShowApplyModal] = useState(false);
  if (!job) return null;

  return (
    <div className="w-full h-full bg-white border-l px-10 py-6 overflow-y-auto">
      <div className="px-10 py-6 max-w-4xl mx-auto">
        {/* Header Row */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-xl font-bold mb-1">{job.title}</h2>
            <p className="text-sm  font-bold mb-1">{job.company}</p>
            <p className="text-sm text-gray-600 mb-4">{job.location}</p>
            <div className="flex flex-wrap gap-4 text-sm text-gray-700">
              <div className="flex items-center gap-2">
                <FaDollarSign className="text-gray-500" /> $50K / yr
              </div>
              <div className="flex items-center gap-2">
                <FaClock className="text-gray-500" /> Full-time
              </div>
              <div className="flex items-center gap-2">
                <MdCalendarToday className="text-gray-500" /> Posted 22 days ago
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            {job.method === "quick" && (
              <button
                onClick={() => setShowApplyModal(true)}
                className="bg-black hover:bg-black text-white font-semibold px-4 py-2 rounded text-sm flex items-center gap-1"
              >
                <HiOutlineLightningBolt /> Quick Apply
              </button>
            )}
            <button className="border border-gray-300 p-2 rounded text-gray-600 hover:text-black">
              <HiBookmark size={20} />
            </button>
          </div>
        </div>

        {/* Job Description */}
        <div className="mb-8">
          <h3 className="text-md font-bold mb-2">Job description</h3>
          <p className="text-sm text-gray-700 leading-relaxed">
            <strong>New Jersey Groundworks</strong>, A Groundworks Company, is seeking talented <strong>Construction General Laborers</strong> to join their team in <strong>South Plainfield, NJ</strong>!<br /><br />
            The Installer is a vital member of our crew and will travel (in a company-provided vehicle) to homes in the general area to install foundation repair, crawl space encapsulation, basement waterproofing, and concrete lifting solutions. Candidates with previous experience in construction, home services, trade work, general labor, and landscaping would be a great fit for this position.<br /><br />
            <strong>What we provide for our General Labor employees:</strong>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Bi-weekly Pay & weekly bonus opportunities ($0k-$50k per year)</li>
              <li>All tools & transportation to the job site included</li>
              <li>Full-time nonseasonal work, we work year-round!</li>
              <li>Employee Ownership</li>
              <li>Company-sponsored certification programs & career development</li>
              <li>Competitive and rewarding, family-oriented culture</li>
              <li>Advanced leadership training opportunities as a laborer - become a Foreman in 1 year</li>
              <li>Benefits include Medical, Dental, Vision, Life insurance, 401(k) retirement program with a company match, 2 weeks paid time off & 6 holidays</li>
            </ul>
          </p>
        </div>

        <button
          onClick={onClose}
          className="text-sm text-[#004349] font-medium underline hover:text-black"
        >
          Close Details
        </button>
      </div>

      {showApplyModal && (
        <QuickApplyModal job={job} onClose={() => setShowApplyModal(false)} />
      )}
    </div>
  );
};

export default JobDetails;
